const STORAGE_KEY = "guestDiagnostic:template_27";

export interface GuestDiagnosticPayload {
  kind: string;
  answers: Record<string, number>;
  resultType: string;
  completedAt: string;
}

export function saveGuestDiagnostic(payload: GuestDiagnosticPayload): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // localStorageが使えない環境は無視
  }
}

export function loadGuestDiagnostic(): GuestDiagnosticPayload | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as GuestDiagnosticPayload;
    if (!parsed.answers || !parsed.resultType) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearGuestDiagnostic(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // 無視
  }
}
